export const required = (value: any) => (value ? undefined : 'Required');
export const notRequired = () => undefined;

export const mustBeNumber = (value: any) =>
  isNaN(value) ? 'Must be a number' : undefined;

export const minValue = (min: number) => (value: any) =>
  isNaN(value) || Number(value) >= min ? undefined : `Min value: ${min}`;
export const maxValue = (max: number) => (value: any) =>
  isNaN(value) || Number(value) <= max ? undefined : `Max value: ${max}`;

export const composeValidators =
  (validators: ((value: any) => string | undefined)[]) =>
  (value: any): string | undefined => {
    return validators.reduce((error: string | undefined, validator) => {
      return error || validator(value);
    }, undefined);
  };
